<template>
    <div class="container">
        <div class="form-box login">
            <form>
                <div class="input-box">
                    <input type="text" id="num_empleado" placeholder="No. Empleado" disabled />
                    <i class="bi bi-person-badge"></i>
                </div>
                <div class="input-box">
                    <input type="text" id="nombre_empleado" placeholder="Nombre Empleado" disabled />
                    <i class="bi bi-person-circle"></i>
                </div>
                <div class="input-box">
                    <input type="password" placeholder="Nueva Contraseña" id="nueva_contrasena" required
                        autocomplete="off" />
                    <i class="bi bi-key"></i>
                </div>
                <div class="input-box">
                    <input type="password" placeholder="Confirmar Nueva Contraseña" id="confirmar_contrasena" required
                        autocomplete="off" />
                    <i class="bi bi-key-fill"></i>
                </div>
                <button type="submit" id="btn_change_password" class="btn">Cambiar Contraseña</button>
            </form>
        </div>
        <div class="toggle-box">
            <div class="toggle-panel toggle-left">
                <h1>Nueva Contraseña</h1>
                <button class="btn btn-back" id="btn-back-home">
                    <span class="icon-container">
                        <i class="bi bi-arrow-left"></i>
                    </span>
                    <router-link to="/">
                        Volver a Inicio
                    </router-link>
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped src="../styles/changePassword.css"></style>